const isCustomNode = () => null
export default isCustomNode
